// extracted by mini-css-extract-plugin
export default {"div":"Notification_div__+6ihU"};